module.exports = __webpack_public_path__ + "img/404.d9411366.svg";